import { WhichWeightAPI } from 'WhichWeightAPI'
import { ChevronRightIcon } from '@heroicons/react/24/outline'
import { UserPlusIcon } from '@heroicons/react/24/outline'
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import moment from 'moment'

import ScreenFrame from 'components/Frame/ScreenFrame'

export default function ReportingOverview() {
    const navigate = useNavigate()

    const email = useSelector((state) => state.user.email)

    // Total Sign Up Variables
    const [totalSignUps, setTotalSignUps] = useState(0)
    var stats = [
        {
            id: 1,
            name: 'Total Kinesis Sign Ups',
            stat: totalSignUps,
            icon: UserPlusIcon,
        },
    ]

    // Most Active Users Variables
    const [mostActiveUsers, setMostActiveUsers] = useState([])

    // Users Active in the Past Week Variables
    const [pastWeekActiveUsers, setPastWeekActiveUsers] = useState([])

    const GetTotalSignUpsFromBackend = async () => {
        const result = await WhichWeightAPI('REPORTING', 'GET', '/sign_up_count')

        // console.log(result);

        setTotalSignUps(result.data.data.count)
    }

    const GetMostActiveUsersFromBackend = async () => {
        const result = await WhichWeightAPI('REPORTING', 'GET', '/most_active_users')

        // console.log(result.data.data);

        setMostActiveUsers(result.data.data)
    }

    const GetPastWeekActiveUsers = async () => {
        const result = await WhichWeightAPI('REPORTING', 'GET', '/past_week_active_users')

        // console.log(result.data.data);

        setPastWeekActiveUsers(result.data.data)
    }

    const OnUserCardPressed = (userId) => {
        const navigationProps = {
            state: {
                userId: userId,
            },
        }

        navigate('/reporting/user/activity', navigationProps)
    }

    const GetUserSubscriptionStatuses = async () => {
        const result = await WhichWeightAPI("BILLING", "GET", "/all_user_subscription_statuses");

        console.log(result.data.data)
    }

    useEffect(() => {
        GetTotalSignUpsFromBackend()
        GetMostActiveUsersFromBackend()
        GetPastWeekActiveUsers()
    }, [])

    return (
        <ScreenFrame>
            {/* Title */}
            <div className="text-2xl font-semibold">Kinesis Usage</div>

            {/* Total Sign Ups Stat */}
            <dl className="grid gap-4 grid-cols-3">
                {stats.map((item) => (
                    <div key={item.id} className="rounded-lg bg-white p-4 shadow border border-stone-100 relative">
                        <div className="absolute rounded-md bg-orange-600 p-3">
                            <item.icon className="h-6 w-6 text-white" aria-hidden="true" />
                        </div>

                        <p className="ml-16 truncate text-sm font-medium text-gray-500">{item.name}</p>

                        <dd className="ml-16 flex items-baseline">
                            <p className="text-2xl font-semibold text-gray-900">{item.stat}</p>
                        </dd>
                    </div>
                ))}
            </dl>

            <div className='flex gap-x-4'>
                <div 
                    className='border border-gray-200 shadow-sm rounded-md py-2 text-center cursor-pointer flex-1'
                    onClick={GetUserSubscriptionStatuses}
                >
                    Get All User Subscription Statuses
                </div>
            </div>

            {/* Users Active in the past week */}
            <div>
                {/* Table Title */}
                <h1 className="font-semibold leading-6 text-gray-900">Users Active in the Past Week</h1>

                <div className="mt-4 flow-root">
                    <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                                <table className="min-w-full divide-y divide-gray-300">
                                    <thead className="bg-gray-50">
                                        <tr>
                                            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                                Name
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                Email
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                Last Login Date
                                            </th>
                                            <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                                                <span className="sr-only">View</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200 bg-white">
                                        {pastWeekActiveUsers.map((user) => (
                                            <tr key={user.id} onClick={() => OnUserCardPressed(user.id)} className="hover:bg-gray-50 cursor-pointer">
                                                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                                    {user.firstName} {user.lastName}
                                                </td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{user.email}</td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{moment(user.loginDate).format('MMMM DD, YYYY')}</td>
                                                <td className="flex justify-end py-3.5 pr-4 text-gray-400">
                                                    <ChevronRightIcon className="h-6" />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Most Active Users */}
            <div>
                {/* Table Title */}
                <h1 className="font-semibold leading-6 text-gray-900">Most Active Users</h1>

                <div className="mt-4 flow-root">
                    <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                                <table className="min-w-full divide-y divide-gray-300">
                                    <thead className="bg-gray-50">
                                        <tr>
                                            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                                Name
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                Email
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                Number of Logins
                                            </th>
                                            <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                                                <span className="sr-only">View</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200 bg-white">
                                        {mostActiveUsers.map((user) => (
                                            <tr key={user.id} onClick={() => OnUserCardPressed(user.id)} className="hover:bg-gray-50 cursor-pointer">
                                                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                                    {user.firstName} {user.lastName}
                                                </td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{user.email}</td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{user.logins} logins</td>
                                                <td className="flex justify-end py-3.5 pr-4 text-gray-400">
                                                    <ChevronRightIcon className="h-6" />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ScreenFrame>
    )
}
